import { render, staticRenderFns } from "./BackofficeRetornoOperadora.vue?vue&type=template&id=38b1e084"
import script from "./BackofficeRetornoOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeRetornoOperadora.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports